/* @generated */

// ../src/stepper/hidden_steps.tsx
import { Text } from "@dropbox/dig-components/typography";
import * as React from "react";
import { useMeasure } from "@react-hookz/web";

// ../src/stepper/index.css.ts
import { createRuntimeFn as _7a468 } from "@vanilla-extract/recipes/createRuntimeFn";
var hiddenStep = "dig-wyoh0zd_20-11-1 dig-wyoh0z8_20-11-1 dig-wyoh0z7_20-11-1";
var stepAccessory = _7a468({ defaultClassName: "dig-wyoh0z9_20-11-1", variantClassNames: { state: { disabled: "dig-wyoh0za_20-11-1", current: "dig-wyoh0zb_20-11-1", complete: "dig-wyoh0zc_20-11-1" } }, defaultVariants: {}, compoundVariants: [] });
var stepDivider = _7a468({ defaultClassName: "dig-wyoh0z4_20-11-1", variantClassNames: { inactive: { true: "dig-wyoh0z5_20-11-1", false: "dig-wyoh0z6_20-11-1" } }, defaultVariants: {}, compoundVariants: [] });
var stepLabel = "dig-wyoh0z8_20-11-1 dig-wyoh0z7_20-11-1";
var stepLabelColumn = "dig-wyoh0z7_20-11-1";
var stepStyles = _7a468({ defaultClassName: "dig-wyoh0z1_20-11-1", variantClassNames: { clickable: { true: "dig-wyoh0z2_20-11-1", false: "dig-wyoh0z3_20-11-1" } }, defaultVariants: {}, compoundVariants: [] });
var stepperComponent = "dig-wyoh0z0_20-11-1";

// ../src/stepper/hidden_steps.tsx
var HiddenStep = ({ index, step, setSize }) => {
  const [measurements, measurementRef] = useMeasure();
  if (measurements) {
    setSize(measurements.width, index);
  }
  return /* @__PURE__ */ React.createElement("div", { className: hiddenStep, ref: measurementRef }, /* @__PURE__ */ React.createElement(Text, { isBold: true, "data-testid": "hidden-text" }, step.label), step.subText && /* @__PURE__ */ React.createElement(Text, { "data-testid": "hidden-text", size: "small", color: "subtle" }, step.subText));
};
var HiddenSteps = ({ steps, setSize }) => {
  return /* @__PURE__ */ React.createElement(
    React.Fragment,
    null,
    // Render hidden steps to calculate size of the labels
    steps.map((step, index) => {
      return /* @__PURE__ */ React.createElement(HiddenStep, { key: `hidden-${index}`, index, step, setSize });
    })
  );
};

// ../src/stepper/hooks.ts
import * as React2 from "react";

// ../src/_global/constants.ts
var TAB_KEY = "Tab";
var LEFT_ARROW_KEY = "ArrowLeft";
var RIGHT_ARROW_KEY = "ArrowRight";
var buttonDataAttributeName = "data-dig-button";
var buttonDataSelector = `[${buttonDataAttributeName}]`;
var buttonContentDataAttributeName = "data-dig-button-content";
var buttonContentDataSelector = `[${buttonContentDataAttributeName}]`;
var splitButtonDataAttributeName = "data-dig-split-button";
var splitButtonDataSelector = `[${splitButtonDataAttributeName}]`;
var iconButtonDataAttributeName = "data-dig-icon-button";
var iconButtonDataSelector = `[${iconButtonDataAttributeName}]`;

// ../src/stepper/hooks.ts
import { useDebouncedCallback, useResizeObserver } from "@react-hookz/web";

// ../src/stepper/utils.ts
var getStepState = ({ index, currentIndex, completeIndex }) => {
  return index === currentIndex ? "current" : index > completeIndex ? "disabled" : "complete";
};
var getShouldShowLabel = ({ calculatedResponsive, state }) => {
  return calculatedResponsive === "accessories-and-labels" || calculatedResponsive === "accessories-and-current-label" && state === "current";
};
var stepperIconsOnlyWidth = (numberOfSteps) => {
  return numberOfSteps * (32 + 16 + 48) - 48;
};
var getCalculatedResponsiveAppearance = (inputWidth, labelSizes, numSteps, currentIndex) => {
  const width = inputWidth > 0 ? Math.floor(inputWidth) : 0;
  const allLabelsWidth = labelSizes.reduce(
    (partialSum, currentWidth) => partialSum + currentWidth,
    0
  );
  const currentLabelWidth = labelSizes[currentIndex];
  const iconsOnlyWidth = stepperIconsOnlyWidth(numSteps);
  if (width < iconsOnlyWidth) {
    return "current-label-only";
  }
  if (width < iconsOnlyWidth + currentLabelWidth) {
    return "accessories-only";
  }
  if (width < iconsOnlyWidth + allLabelsWidth) {
    return "accessories-and-current-label";
  }
  return "accessories-and-labels";
};
var IsInteractiveStepper = (props) => {
  return "completeIndex" in props;
};

// ../src/stepper/hooks.ts
var useKeyboardFocus = ({
  currentIndex,
  total,
  userOnKeyDown
}) => {
  const [focusIndex, setFocusIndex] = React2.useState(currentIndex);
  const [isKeyboardFocus, setIsKeyboardFocus] = React2.useState(false);
  React2.useEffect(() => {
    setFocusIndex(currentIndex);
  }, [currentIndex]);
  const onKeyDown = (event) => {
    if (event.key === LEFT_ARROW_KEY && focusIndex > 0) {
      setFocusIndex(focusIndex - 1);
      setIsKeyboardFocus(true);
      event.preventDefault();
    } else if (event.key === RIGHT_ARROW_KEY && focusIndex < total - 1) {
      setFocusIndex(focusIndex + 1);
      setIsKeyboardFocus(true);
      event.preventDefault();
    } else if (event.key === TAB_KEY) {
      setIsKeyboardFocus(false);
    }
    if (userOnKeyDown) {
      userOnKeyDown(event);
    }
  };
  return { onKeyDown, isKeyboardFocus, focusIndex };
};
var STEPPER_STEP_PADDING = 12;
var useResponsiveStepper = ({
  responsive,
  steps,
  currentIndex
}) => {
  const [containerRef, setContainerRef] = React2.useState(null);
  const labelSizes = React2.useRef([]);
  const [autoResult, setAutoResult] = React2.useState(
    "accessories-and-current-label"
  );
  const roCallback = React2.useCallback(() => {
    const result = getCalculatedResponsiveAppearance(
      containerRef ? containerRef.getBoundingClientRect().width : 0,
      labelSizes.current,
      steps.length,
      currentIndex
    );
    setAutoResult(result);
  }, [containerRef, currentIndex, steps.length]);
  const updateIfResizeObserverEntry = useDebouncedCallback(
    (entry) => {
      if (!entry || responsive !== "auto")
        return;
      roCallback();
    },
    [currentIndex, steps, responsive, containerRef],
    10
  );
  useResizeObserver(responsive === "auto" ? containerRef : null, updateIfResizeObserverEntry);
  const calculatedResponsive = React2.useMemo(() => {
    return responsive === "auto" ? autoResult : responsive;
  }, [autoResult, responsive]);
  const debouncedROCallback = useDebouncedCallback(roCallback, [roCallback], 100);
  const updateHiddenLabelSize = (size, index) => {
    const newSize = Math.ceil(size + STEPPER_STEP_PADDING);
    if (!labelSizes.current[index] || labelSizes.current[index] !== newSize) {
      labelSizes.current[index] = newSize;
      debouncedROCallback();
    }
  };
  return {
    setContainerRef,
    calculatedResponsive,
    updateHiddenLabelSize
  };
};

// ../src/stepper/progress_line.tsx
import * as React3 from "react";
import cls from "classnames";
var ProgressLine = ({ isInactive }) => {
  return /* @__PURE__ */ React3.createElement(
    "span",
    {
      className: cls(
        "dig-Stepper-divider",
        {
          "dig-Stepper-divider--inactive": isInactive
        },
        stepDivider({ inactive: isInactive })
      )
    }
  );
};

// ../src/stepper/accessory.tsx
import cls2 from "classnames";
import * as React4 from "react";
var Accessory = ({ content, state, className, ...rest }) => {
  return /* @__PURE__ */ React4.createElement(
    "span",
    {
      ...rest,
      className: cls2(
        "dig-Stepper-accessory",
        className,
        {
          "dig-Stepper-accessory--current": state === "current",
          "dig-Stepper-accessory--disabled": state === "disabled"
        },
        stepAccessory({ state })
      )
    },
    content
  );
};
Accessory.displayName = "Accessory";

// ../src/stepper/step.tsx
import { Text as Text2 } from "@dropbox/dig-components/typography";

// ../src/_global/innerText.ts
var hasProps = (node) => Object.prototype.hasOwnProperty.call(node, "props");
var reduceNodeToString = (previous, current) => previous + innerText(current);
var innerText = (node) => {
  if (node === null || typeof node === "boolean" || typeof node === "undefined") {
    return "";
  }
  if (typeof node === "number") {
    return node.toString();
  }
  if (typeof node === "string") {
    return node;
  }
  if (Array.isArray(node)) {
    return node.reduce(reduceNodeToString, "");
  }
  if (hasProps(node) && Object.prototype.hasOwnProperty.call(node.props, "children")) {
    return innerText(node.props.children);
  }
  return "";
};

// ../src/stepper/step.tsx
import cls3 from "classnames";
import * as React5 from "react";
import { Tooltip } from "@dropbox/dig-components/tooltips";
import { withShade } from "@dropbox/dig-foundations";
var Step = ({
  step,
  state,
  index,
  tabIndex,
  applyFocus,
  showLabel,
  summary,
  onChange
}) => {
  const buttonRef = React5.useRef(null);
  const stepIsClickable = onChange && state !== "disabled";
  const onStepClick = () => {
    if (stepIsClickable) {
      onChange(index);
    }
  };
  React5.useEffect(() => {
    if (applyFocus && buttonRef.current) {
      buttonRef.current.focus();
    }
  }, [applyFocus, tabIndex, state]);
  const TagName = stepIsClickable ? "button" : "span";
  const stepComponent = (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /* @__PURE__ */ React5.createElement(
      TagName,
      {
        ref: buttonRef,
        ...withShade({
          className: cls3(
            "dig-Stepper-step",
            {
              "dig-Stepper-step--pointerEvents": stepIsClickable
            },
            stepStyles({ clickable: stepIsClickable })
          ),
          // Effectively disables the shade if the step isn't clickable
          state: !stepIsClickable ? "default" : void 0
        }),
        onClick: stepIsClickable ? onStepClick : void 0,
        "aria-disabled": state === "disabled",
        tabIndex,
        "aria-label": `${innerText(summary)}, ${innerText(step.label)}`
      },
      /* @__PURE__ */ React5.createElement(Accessory, { content: step.accessory || index + 1, state }),
      showLabel && /* @__PURE__ */ React5.createElement("div", { className: cls3("dig-Stepper-label", stepLabel) }, /* @__PURE__ */ React5.createElement(
        Text2,
        {
          variant: "label",
          className: "dig-Stepper-label--text",
          color: state === "disabled" ? "disabled" : "standard"
        },
        step.label
      ), step.subText && /* @__PURE__ */ React5.createElement(
        Text2,
        {
          variant: "label",
          size: "small",
          color: state === "disabled" ? "disabled" : "subtle",
          className: "dig-Stepper-sublabel"
        },
        step.subText
      ))
    )
  );
  const tooltipContent = !showLabel ? step.label : void 0;
  return tooltipContent ? /* @__PURE__ */ React5.createElement(Tooltip, { title: tooltipContent, triggerRef: buttonRef }, stepComponent) : stepComponent;
};
Step.displayName = "Step";

// ../src/stepper/stepper.tsx
import { Text as Text3 } from "@dropbox/dig-components/typography";
import cls4 from "classnames";
import * as React6 from "react";

// ../src/_global/resize_observer_polyfill.ts
import { ResizeObserver as ResizeObserverPolyfill } from "@juggle/resize-observer";
var polyfillResizeObserverGlobally = () => {
  if ("ResizeObserver" in globalThis === false) {
    globalThis.ResizeObserver = ResizeObserverPolyfill;
  }
};

// ../src/stepper/stepper.tsx
polyfillResizeObserverGlobally();
var LabelOnlyStepper = ({ label, summary }) => {
  return /* @__PURE__ */ React6.createElement("div", { key: "stepper-label-only", className: cls4("dig-Stepper--label-only", stepLabelColumn) }, /* @__PURE__ */ React6.createElement(Text3, null, label), /* @__PURE__ */ React6.createElement(Text3, { color: "subtle", size: "small" }, summary));
};
LabelOnlyStepper.displayName = "LabelOnlyStepper";
var Stepper = (props) => {
  const {
    steps,
    currentIndex,
    responsive = "auto",
    localizedSummary,
    completeIndex,
    onChange,
    className,
    onKeyDown: userOnKeyDown,
    ...rest
  } = IsInteractiveStepper(props) ? props : { completeIndex: props.currentIndex, onChange: void 0, ...props };
  const { focusIndex, onKeyDown, isKeyboardFocus } = useKeyboardFocus({
    currentIndex,
    total: steps.length,
    userOnKeyDown
  });
  const { calculatedResponsive, setContainerRef, updateHiddenLabelSize } = useResponsiveStepper({
    steps,
    currentIndex,
    responsive
  });
  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /* @__PURE__ */ React6.createElement(
      "div",
      {
        ...rest,
        ref: (el) => setContainerRef(el),
        onKeyDown,
        className: cls4("dig-Stepper", stepperComponent, className)
      },
      /* @__PURE__ */ React6.createElement(HiddenSteps, { key: "hidden-steps", steps, setSize: updateHiddenLabelSize }),
      steps.map((step, index) => {
        const stepState = getStepState({ index, currentIndex, completeIndex });
        const showLabel = getShouldShowLabel({ state: stepState, calculatedResponsive });
        if (calculatedResponsive === "current-label-only") {
          if (currentIndex !== index) {
            return null;
          }
          return /* @__PURE__ */ React6.createElement(
            LabelOnlyStepper,
            {
              key: calculatedResponsive,
              label: step.label,
              summary: localizedSummary(currentIndex + 1, steps.length)
            }
          );
        }
        return (
          // Can't use <></> with a key
          /* @__PURE__ */ React6.createElement(
            React6.Fragment,
            { key: `step-${index}` },
            /* @__PURE__ */ React6.createElement(
              Step,
              {
                onChange,
                state: stepState,
                tabIndex: focusIndex === index ? 0 : -1,
                applyFocus: focusIndex === index && isKeyboardFocus,
                step,
                index,
                showLabel,
                summary: localizedSummary(index + 1, steps.length)
              }
            ),
            // Do not leave a trailing line divider
            index !== steps.length - 1 && /* @__PURE__ */ React6.createElement(ProgressLine, { isInactive: completeIndex - 1 < index })
          )
        );
      })
    )
  );
};
Stepper.displayName = "Stepper";
export {
  Stepper
};
